import { Routes } from '@angular/router';
import { ContactoComponent } from './components/contacto/contacto.component';
import { EstudiosComponent } from './components/estudios/estudios.component';
import { GaleriaComponent } from './components/galeria/galeria.component';
import { HomeComponent } from './components/home/home.component';
import { TutorialesComponent } from './components/tutoriales/tutoriales.component';
import { BlogComponent } from './components/blog/blog.component';
import { PruebaComponent } from './components/prueba/prueba.component';
import { ProyectosComponent } from './components/proyectos/proyectos.component';
import { AboutMeComponent } from './components/about-me/about-me.component';
import { HabilidadesComponent } from './components/habilidades/habilidades.component';


export const ROUTES: Routes = [
    {path: 'home', component: HomeComponent},
    {path: 'tutoriales', component: TutorialesComponent},
    {path: 'estudios', component: EstudiosComponent},
    {path: 'galeria', component: GaleriaComponent},
    {path: 'contacto', component: ContactoComponent},
    {path: 'blog', component: BlogComponent},
    {path: 'prueba', component: PruebaComponent},
    {path: 'proyectos', component: ProyectosComponent},
    {path: 'habilidades', component: HabilidadesComponent},
    {path: 'aboutMe', component: AboutMeComponent},
    {path: '', pathMatch: 'full', redirectTo: 'home'},
    {path: '**', pathMatch: 'full', redirectTo: 'home'},
];